import { render, staticRenderFns } from "./EditManningHistory.vue?vue&type=template&id=2adb96da&scoped=true&"
import script from "./EditManningHistory.vue?vue&type=script&lang=js&"
export * from "./EditManningHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adb96da",
  null
  
)

export default component.exports